module.exports = __webpack_public_path__ + "media/landing_page/iss2-b7e245f1.jpg";